import React from "react";
import SupportService from "./SupportService";
import ServiceMission from "./ServiceMission";
import CaseCategories from "./CaseCategories";
const ServicePage = () => {
  return (
    <div style={styles.mainWrapper}>
      <SupportService />
      <ServiceMission />
      <CaseCategories />
      
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  mainWrapper: {
    marginTop:"var(--header-height)",
    overflowX: "hidden",
  },
};

export default ServicePage;
